// Format info: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
export const BIRTH_DATE_SERVER_FORMAT = 'yyyy-MM-dd';
export const BIRTH_DATE_DISPLAY_FORMAT = 'MM / dd / yyyy';
export const BIRTH_DATE_DISPLAY_FORMAT_NO_SPACES = 'MM/dd/yyyy';
